/**
 * Cyber-Minimal Button Component
 * 
 * @param {Object} props
 * @param {string} props.label - Button text
 * @param {string} props.type - 'primary' | 'secondary' | 'outline'
 * @param {boolean} props.disabled - Disabled state
 * @param {Function} props.onClick - Click handler
 */
export function createButton({ label, type = 'primary', disabled = false, onClick }) {
  const button = document.createElement('button');
  button.className = `cm-button cm-button--${type}`;
  button.textContent = label;
  
  if (disabled) {
    button.disabled = true;
  }
  
  if (onClick) {
    button.addEventListener('click', onClick);
  }
  
  return button;
}
